import { render } from "./GlossaryUsageLinkTree.vue?vue&type=template&id=81b8b49c&scoped=true&ts=true"
import script from "./GlossaryUsageLinkTree.vue?vue&type=script&lang=ts"
export * from "./GlossaryUsageLinkTree.vue?vue&type=script&lang=ts"

import "./GlossaryUsageLinkTree.vue?vue&type=style&index=0&id=81b8b49c&scoped=true&lang=css"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b8b49c"]])

export default __exports__